import React, { useEffect, useState, useRef } from 'react';
import { useLoadingContext, LoadingContext } from "react-router-loading";
import classNames from "classnames";

// import JitsiPublisher from './lib/JitsiPublisher';
// import * as utils from './lib/utils';
import * as api from './lib/api';
import { RemoteClient } from './lib/RemoteClient';
import VBPublisher from './lib/VBPublisher';
import VBRoom from './lib/VBRoom';

const JitsiMeetJS = window.JitsiMeetJS;

// window._firstVisit = true;

const SEAT_COUNT = 6;

class SceneMain extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.isLoading = true;
        this.isStreaming = false;
        this.roomInfo = {};
        this.inputSettings = {};
        this.inputTracks = {};

        this.rooms = {};

        this.refCameraTopViewVideo = React.createRef();
        this.refCameraBillboardVideo = React.createRef();
        this.refCanvas = React.createRef();

        window.SceneMain = this;
    }

    get videoRoomId() {
        return this.roomInfo?.video_room_id;
    }

    loading = async () => {
        this.isLoading = true;
        this.setState({ ...this.state });

        // await new Promise((resolve) => { setTimeout(resolve, 3000); });

        this.dispose();
        await this.init();

        // console.log(`loading state ===> set loading false`);
        this.isLoading = false;
        this.setState({ ...this.state });
        this.props.loadingContext.done();

        // console.log(`loading state ===> done`);
    };

    dispose() {
        // console.log(`dispose:inputTracks`, inputTracks);
        this.stopStreaming();
        let inputTracks = this.inputTracks;
        if (!!inputTracks.top) {
            inputTracks.top.dispose();
            inputTracks.top = null;
        }
        if (!!inputTracks.billboard) {
            inputTracks.billboard.dispose();
            inputTracks.billboard = null;
        }
    }

    getCameraOutputs() {
        let top = 'data:,';
        let billboard = 'data:,';
        try {
            top = this.takeScreenshot(this.refCameraTopViewVideo.current);
        } catch (e) { }
        try {
            billboard = this.takeScreenshot(this.refCameraBillboardVideo.current);
        } catch (e) { }
        return {
            top,
            billboard
        }
    }

    takeScreenshot(video) {
        let canvas = this.refCanvas.current;
        let ratio = video.videoWidth / video.videoHeight;
        let w = video.videoWidth - 100;
        let h = parseInt(w / ratio, 10);
        canvas.width = w;
        canvas.height = h;
        var context = canvas.getContext('2d');
        context.fillRect(0, 0, w, h);
        context.drawImage(video, 0, 0, w, h);
        const dataURL = canvas.toDataURL();
        // console.log(`takeScreenshot`, `w=${w}, h=${h}`, `dataURL=`, dataURL);
        return dataURL;
    }

    componentDidMount() {
        window._main = this;
        // console.log(`SceneMain mounted!`);
        this.loading();
        RemoteClient.setApp(this);
        this._intervalId = setInterval(() => this.intervalVideoChecking(), 2000);
    }

    componentWillUnmount() {
        // console.log(`SceneMain unounted!`);
        if (!!this._intervalId) clearInterval(this._intervalId);
        RemoteClient.setApp(null);
        this.dispose();
    }

    componentDidUpdate() {
        // console.log(`componentDidUpdate`);
    }

    intervalVideoChecking() {
        if (!this.isStreaming) {
            return;
        }
        this.setState({ ...this.state });
    }

    init() {
        return new Promise(async (resolve, reject) => {
            let videoInputs = api.getSavedInputs();
            console.log(`loadSettings:inputs`, videoInputs);
            this.inputSettings = videoInputs;

            this.onVideoInputChange('top', videoInputs?.cameraTop?.value);
            this.onVideoInputChange('billboard', videoInputs?.cameraBillBoard?.value);

            let roomId = api.getSavedTableId();
            console.log(`loadSettings:roomId`, roomId);

            let roomInfo = await api.getTable(roomId);
            console.log(`loadSettings:roomInfo`, roomInfo);
            this.roomInfo = roomInfo;

            this.startStreaming();

            this.setState({
                ...this.state
            });

            resolve();
        });
    }

    onVideoInputChange(view, deviceId) {
        // console.log(`onVideoInputChange`, view, deviceId);
        let videoElement = null;
        let _inputTracks = this.inputTracks;

        switch (view) {
            case 'top':
                videoElement = this.refCameraTopViewVideo.current;
                break;
            case 'billboard':
                videoElement = this.refCameraBillboardVideo.current;
                break;
            default:
                break;
        }
        // console.log(`onVideoInputChange:attach`, view, deviceId, videoElement);

        if (!!videoElement) {
            JitsiMeetJS.createLocalTracks({
                devices: ['video'],
                cameraDeviceId: deviceId
            }).then((tracks) => {
                // console.log(`onVideoInputChange`, tracks);
                if (!!_inputTracks[view]) {
                    _inputTracks[view].dispose();
                }
                for (let i = 0; i < tracks.length; i++) {
                    // attach to HTML frontend
                    if (tracks[i].getType() === 'video') {
                        tracks[i].attach(videoElement);
                        _inputTracks[view] = tracks[i];
                    }
                }

                // console.log(`onVideoInputChange:_inputTracks`, view, deviceId, videoElement, _inputTracks);
                // window._inputTracks = _inputTracks; // FIXME: DEBUG CONSOLE
                this.inputTracks = _inputTracks;
                this.setState({ ...this.state });
            }).catch((error) => {
                console.error(`createLocalTracks:error`, error);
            });
        }
        // this.inputTracks = _inputTracks;
    }

    isReadyForPublish() {
        let inputTracks = this.inputTracks;
        let _isReadyPublish = (inputTracks.top && inputTracks.top.isLocal() && !inputTracks.top.disposed)
            && (inputTracks.billboard && inputTracks.billboard.isLocal() && !inputTracks.billboard.disposed);
        _isReadyPublish = !!_isReadyPublish;
        return _isReadyPublish;
    }

    toggleStreaming() {
        let toggleState = !this.isStreaming;
        console.log(`toggleStreaming: isStreaming=`, toggleState, `videoRoomId=`, this.videoRoomId, `roomInfo=`, this.roomInfo);

        if (toggleState) {
            this.startStreaming();
        } else {
            this.stopStreaming();
        }
    }

    reloadSettings() {
        this.loading();
    }

    startStreaming() {
        if (this.isStreaming) return;
        if (!this.isReadyForPublish) return;
        console.log(`startStreaming`);
        this.setState({ ...this.state });

        for (let i = 1; i <= SEAT_COUNT; i++) {
            let rid = `${this.videoRoomId}_${i}`;
            this.rooms[rid] = new VBRoom(this, rid);
            this.rooms[rid].startStreaming();
        }

        this.isStreaming = true;
    }

    stopStreaming() {
        if (!this.isStreaming) return;
        console.log(`stopStreaming`);
        this.isStreaming = false;
        this.setState({ ...this.state });

        for (let i = 1; i <= SEAT_COUNT; i++) {
            let rid = `${this.videoRoomId}_${i}`;
            this.rooms[rid].stopStreaming();
        }
    }

    render() {
        // console.log(`render(): isLoading=`, this.isLoading);
        return (
            <div className="container">
                <p className={classNames({
                    'placeholder-glow': true,
                    'd-none': !this.isLoading,
                })}>
                    <span className="placeholder col-8"></span>
                    <span className="placeholder col-8"></span>
                    <span className="placeholder col-12"></span>
                    <span className="placeholder col-12"></span>
                    <span className="placeholder col-12"></span>
                </p>

                <div className={classNames({
                    'd-none': this.isLoading,
                })}
                >
                    <div className="row mt-3">
                        <div className="col">
                            <div className="card">
                                <div className="card-header">
                                    Room Information
                                </div>
                                <div className="card-body">
                                    <h5 className="card-title">{this.roomInfo.name}</h5>
                                    <div className="card-text">
                                        <dl className="row">
                                            <dt className="col-sm-3">Name</dt>
                                            <dd className="col-sm-9">{this.roomInfo.name} - {this.roomInfo.game_type?.name}</dd>

                                            <dt className="col-sm-3">ID</dt>
                                            <dd className="col-sm-9">{this.roomInfo.id}</dd>

                                            <dt className="col-sm-3">VideoID</dt>
                                            <dd className="col-sm-9"><mark>{this.roomInfo.video_room_id}</mark></dd>

                                            <dt className="col-sm-3">Status</dt>
                                            <dd className="col-sm-9">
                                                {this.roomInfo.status === 'opened'
                                                    ?
                                                    <span className='badge text-bg-success'>Open</span>
                                                    :
                                                    <span className='badge text-bg-warning'>Closed</span>
                                                }
                                            </dd>
                                        </dl>
                                    </div>
                                    {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 mt-3">
                        <div className="col camera-viewport">
                            <span className="jitsi-name badge text-bg-primary">Top</span>

                            <div id="camera_top">
                                <video width="100%" autoPlay="1" ref={this.refCameraTopViewVideo} />
                            </div>
                        </div>
                        <div className="col camera-viewport">
                            <span className="jitsi-name badge text-bg-primary">Billboard</span>
                            <div id="camera_billboard">
                                <video width="100%" autoPlay="1" ref={this.refCameraBillboardVideo} />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        {this.isStreaming
                            ?
                            <>
                                <div className='col-12 mt-3'>
                                    <button type="button" className="w-100 btn btn-danger btn-lg" onClick={() => this.toggleStreaming()}>
                                        <i className="bi bi-stop"></i> Stop Streaming
                                    </button>
                                </div>
                            </>
                            :
                            <>
                                <div className='col-12 mt-3'>
                                    <button type="button" className="w-100 btn btn-primary btn-lg" disabled={!this.isReadyForPublish()} onClick={() => this.toggleStreaming()}>
                                        <i className="bi bi-cast"></i> Start Streaming
                                    </button>
                                </div>
                            </>
                        }
                        <div className='col-12 mt-3'>
                            <button type="button" className="w-100 btn btn-primary btn-lg" onClick={() => this.reloadSettings()}>
                                <i className="bi bi-arrow-clockwise"></i> Reload
                            </button>
                        </div>
                    </div>
                </div>

                <canvas className='d-none' width="640" height="480" ref={this.refCanvas}></canvas>
            </div>
        );
    }
}

// we should wrap class component with Context Provider to get access to loading methods
const SceneMainComponentWrapper = (props) =>
    <LoadingContext.Consumer>
        {loadingContext => <SceneMain loadingContext={loadingContext} {...props} />}
    </LoadingContext.Consumer>

export default SceneMainComponentWrapper;